import { render, staticRenderFns } from "./mipIframe.vue?vue&type=template&id=15756568&"
import script from "./mipIframe.vue?vue&type=script&lang=js&"
export * from "./mipIframe.vue?vue&type=script&lang=js&"
import style0 from "./mipIframe.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports